import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./index.scss";

import { duration } from "utils";
// ui
import { Row, Col, Button } from "antd";
// animations
import { Fade } from "react-reveal";

const times = [
  {
    title: "Instant Unlock",
    value: "60% Deduction",
  },
  {
    title: "Month 2",
    value: "40% Penalty",
  },
  {
    title: "Month 3",
    value: "20% Penalty",
  },
  {
    title: "Month 4",
    value: "10% Penalty",
  },
  {
    title: "Month 5",
    value: "5% Penalty",
  },
  {
    title: "Month 6",
    value: "0 Penalty",
  },
  {
    title: "Month 7",
    value: "10% Bonus",
  },
  {
    title: "Month 8",
    value: "20% Bonus",
  },
];

const Token = (props) => {
  return (
    <div className="token" ref={props.tokenRef}>
      <div className="tokenContent">
        <Fade bottom duration={duration}>
          <h1>Token</h1>
          <h6>Real scarcity • Real utility • Real value</h6>
        </Fade>

        <Fade bottom duration={duration}>
          <div className="statistic">
            <div className="box">
              <h4>Total coinage</h4>
              <h2>9800</h2>
              <h3>Tokens</h3>
            </div>

            <div className="boxLine" />

            <div className="box">
              <h4>Less locked</h4>
              <h2>5300</h2>
              <h3>Tokens</h3>
            </div>

            <div className="boxLine" />

            <div className="box">
              <h4>Total for sale</h4>
              <h2>4000</h2>
              <h3>Public sale allocation</h3>
            </div>
          </div>
        </Fade>

        <div className="tokenBot">
          <Row gutter={24}>
            <Col md={24} xs={24}>
              <Fade bottom duration={duration}>
                <div className="privateSale">
                  <Button className="btnPrivate">
                    Public sale : 4000 tokens at $1000 each
                  </Button>

                  <h2>
                    All investors can redeem their PCOG tokens at any time.
                  </h2>
                  <p>Special feature: A tax on early unlocks.</p>
                </div>
              </Fade>
            </Col>
            <Col md={24} xs={24}>
              <Fade bottom duration={duration}>
                <div className="structuredTimes">
                  <h4 className="title">
                    There are no mandatory locks. All investors can unlock at
                    any time but are subject to varying tax or bonuses relative
                    to their chosen vesting period.
                  </h4>
                  <Row gutter={20}>
                    {times &&
                      times.map((item, i) => (
                        <Col key={i} lg={6} xs={24}>
                          <Fade bottom duration={duration}>
                            <div className="timeBox">
                              <h4>{item.title}</h4>
                              <h3>{item.value}</h3>
                            </div>
                          </Fade>
                        </Col>
                      ))}
                  </Row>
                </div>

                {/* <div className="structuredTimes viewMobile">
                  <Slider className="sliderTimes" {...settings}>
                    {times &&
                      times.map((item, i) => (
                        <div
                          key={i}
                          className="slideItem"
                          style={{ padding: "0 15px" }}
                        >
                          <div className="timeBox">
                            <h4>{item.title}</h4>
                            <h3>{item.value}</h3>
                          </div>
                        </div>
                      ))}
                  </Slider>
                </div> */}

                {/*                 
                <div className="lookingSchedule">
                  <h3>Lock Terms:</h3>

                  <div className="boxSchedule">
                    {shedules &&
                      shedules.map((item, i) => (
                        <div
                          key={i}
                          className={`boxItem box${i + 1} ${
                            i === 2 || i === index ? "active" : ""
                          } `}
                          onMouseEnter={() => handleHover(i)}
                          onMouseLeave={() => handleLeave()}
                        >
                          <div className="contentBox">
                            <h5>{item.title}</h5>
                            <h4>{item.value}</h4>
                          </div>
                        </div>
                      ))}
                  </div>
                </div> */}
              </Fade>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default Token;
